import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { BuddyWidget } from "@/components/BuddyWidget";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Landing } from "./pages/Landing";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Dashboard } from "./pages/Dashboard";
import { AuditResult } from "./pages/AuditResult";
import { PaymentSuccess } from "./pages/PaymentSuccess";
import { PaymentCancel } from "./pages/PaymentCancel";
import { Booking } from "./pages/Booking";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { Share } from "./pages/Share";
import { Admin } from "./pages/Admin";
import { TeamManage } from "./pages/TeamManage";
import { TeamAccept } from "./pages/TeamAccept";
import { TeamDashboard } from "./pages/TeamDashboard";
import { AdminDirectorate } from "./pages/AdminDirectorate";
import { Terms } from "./pages/Terms";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { AITransparency } from "./pages/AITransparency";
import { Handbook } from "./pages/Handbook";
import { Support } from "./pages/Support";
import { TruthPage } from "./pages/TruthPage";
import { Settings } from "./pages/Settings";
import { VerifyExecutive } from "./pages/VerifyExecutive";
import { OnboardingModal } from "./components/OnboardingModal";

function AppBody() {
  const { user } = useAuth();
  const showOnboarding = user && user.role !== "admin" && !user.is_root_admin && user.onboarding_completed === false;
  return (
    <>
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/audit/:id" element={<AuditResult />} />
          <Route path="/share/:id" element={<Share />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/booking/:auditId" element={<ProtectedRoute><Booking /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/admin/directorate" element={<ProtectedRoute><AdminDirectorate /></ProtectedRoute>} />
          <Route path="/team" element={<ProtectedRoute><TeamManage /></ProtectedRoute>} />
          <Route path="/team/accept" element={<TeamAccept />} />
          <Route path="/team/dashboard" element={<ProtectedRoute><TeamDashboard /></ProtectedRoute>} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/ai-transparency" element={<AITransparency />} />
          <Route path="/handbook" element={<Handbook />} />
          <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
          <Route path="/truth/:brandSlug" element={<TruthPage />} />
          <Route path="/verify/:slug" element={<VerifyExecutive />} />
        </Routes>
      </main>
      <Footer />
      {user && <BuddyWidget />}
      {showOnboarding && <OnboardingModal />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App flex min-h-screen flex-col bg-obsidian text-white">
      <BrowserRouter>
        <AuthProvider>
          <AppBody />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
